<template>
  <div>
    <EditForm
      :activity-data="activity"
      :entities="entities"
      :users="users"
      :handle-create="meta.handleCreate"
      :handle-update="meta.handleUpdate"
      @onSuccess="handleOnSuccess"
      @onCancel="closeModal"
    />
  </div>
</template>
<script>
import ModalMixin from '@/General/Modal/ModalMixin.js'
import EditForm from '@/Modules/Activity/Components/EditForm.vue'
import ActivityModel from '@/Modules/Activity/ActivityModel.js'
import BaseActivityShowMixin from '@/Modules/Activity/Mixins/BaseActivityShowMixin.js'

export default {
  components: { EditForm },

  mixins: [ ModalMixin, BaseActivityShowMixin ],

  props: {
    meta: {
      type: Object,
      default: () => ({}),
    }
  },

  data() {
    return {
      activity: new ActivityModel(this.meta.activity || {}),
    }
  },

  methods: {
    handleOnSuccess(text) {
      this.closeModal(text)
      this.onSuccess && this.onSuccess()
    },
  }
}
</script>
